import { VentureSupport } from '../../../types'
import React from 'react'
import { Table, TableCell, TableHeading } from '../../atoms/Table'
import { A } from '../../atoms/A'
import { css } from '@emotion/react'
import { EmptyCard } from '../../common/EmptyCard'

type Props = {
  list: VentureSupport[]
}

export const VentureSupportTable: React.FC<Props> = (props) => {
  if (props.list.length === 0) {
    return <EmptyCard />
  }

  return (
    <Table>
      <thead>
        <tr>
          <TableHeading>組織名</TableHeading>
          <TableHeading>種別</TableHeading>
          <TableHeading>支援業種</TableHeading>
          <TableHeading>支援先</TableHeading>
        </tr>
      </thead>
      <tbody>
        {props.list.map((support, i) => (
          <tr key={i}>
            <TableCell>
              <A href={support.path} decoration="none">
                {support.name}
              </A>
            </TableCell>
            <TableCell>{support.category}</TableCell>
            <TableCell>{support.industries.join('、')}</TableCell>
            <TableCell>
              {support.supportings.length > 0 && (
                <A href={support.supportings[0].path} decoration="none">
                  {support.supportings[0].name}
                </A>
              )}
              {support.supportings.length > 1 && (
                <span
                  css={css`
                    margin-left: 5px;
                  `}
                >
                  他{support.supportings.length - 1}社
                </span>
              )}
            </TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
